import React from "react";

class ShopHeader extends React.Component{

    render() {
        let shop = this.props.shop
        return (
            <div>
                    <div className="item">
                        <div className="contact  d-flex align-items-center">
                            <div className="container">
                                <div className="columns">
                                    <div className="column is-8 has-text-white">
                                        <div className="mid-large-text">
                                            {shop.name}
                                        </div>
                                        <div className="mt-4 is-size-5">
                                            <span className="zmdi zmdi-gps mr-2"></span>
                                            <span>{shop.address}</span>
                                            {
                                                shop.distance?
                                                    <p>~{shop.distance.toLocaleString()}m from you</p>:<span></span>
                                            }
                                        </div>

                                        <div className="is-size-5 mt-2">
                                            <p><span className="zmdi zmdi-phone mr-2"></span> <span>{shop.phone}</span></p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
            </div>

        );
    }


}


export default ShopHeader;